import api from '@/services/api'
const url = action => `/holdersmsnotice${action}`

export async function postFindByCondition(page, params){
    const { data: res } = await api.post(url('/findByCondition?page=' + page),params)
    return res
}

export async function postFindLogByCondition(page, params){
    const { data: res } = await api.post(url('/findLogByCondition?page=' + page),params)
    return res
}

export async function postSendSMSToHolder(params){
    const { data: res } = await api.post(url('/sendSMSToHolder'),params)
    return res
}